import { DownloadSecurityContainerBaseDataProvider } from './DownloadSecurityContainerBaseDataProvider';
import { DownloadLinksData, DownloadSecurityContainerWindowData } from '../types/download-security-container-data';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';

export class DownloadSecurityContainerGzDataProvider extends DownloadSecurityContainerBaseDataProvider {
  private dataProviderType = DataProviderType.CORE;
  private endpoint = 'Packages';
  private getSecurityContainerDownloadScripts = 'getSecurityContainerDownloadScripts';
  private getSecurityContainerLearnMoreLink = 'getSecurityContainerLearnMoreLink';

  /**
   * should be removed when the old Packages version is cleaned
   * @deprecated
   */
  public async getDownloadSecurityContainerData(): Promise<DownloadSecurityContainerWindowData> {
    const downloadScripts =
      await this.dependencies.api.clients.Packages.GetSecurityContainerDownloadScripts().toPromise();

    if (!downloadScripts) {
      throw new Error('No download Security Container links data');
    }

    const learnMoreLink = await this.dependencies.api.clients.Packages.GetSecurityContainerLearnMoreLink().toPromise();

    if (!learnMoreLink) {
      throw new Error('No Security Container learn more link data');
    }

    return {
      learnMoreLink,
      ...downloadScripts,
    };
  }

  /**
   *
   * @param packageId
   */
  public async getDownloadSecurityContainerLinks(packageId: string): Promise<DownloadSecurityContainerWindowData> {
    const downloadScripts = (await ConsoleRequest.createRequest<any>({
      dataProviderType: this.dataProviderType,
      payload: {
        packageId: packageId,
      },
      endpoint: this.endpoint,
      method: this.getSecurityContainerDownloadScripts,
    })) as DownloadLinksData;

    if (!downloadScripts) {
      throw new Error('No download Security Container links data');
    }

    const learnMoreLink = (await ConsoleRequest.createRequest<any>({
      dataProviderType: this.dataProviderType,
      payload: {
        packageId: packageId,
      },
      endpoint: this.endpoint,
      method: this.getSecurityContainerLearnMoreLink,
    })) as string;

    if (!learnMoreLink) {
      throw new Error('No Security Container learn more link data');
    }

    return {
      learnMoreLink,
      ...downloadScripts,
    };
  }
}
